import { PreChatRoute } from "@leagueplatform/pre-chat";
import { chatInstance } from "./chat-instance";

// `cx-live-chat-pre-chat` scopes the radio-row divider styling
// (`apps/app/src/index.css`) to this route only — the SDK's FHIR
// questionnaire `RadioGroup` doesn't accept a `showItemDividers`
// prop the way the sibling `CheckboxGroup` does, so we style the
// row separators here mirroring the pattern in
// `masonry/register-emblem-actions.tsx:ITEM_DIVIDER_CSS`.
export const LiveChatPreChatRoute = () => (
  <div className="cx-live-chat-pre-chat">
    <PreChatRoute chatInstance={chatInstance} entryPoint="human" />
  </div>
);
